import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { MtUser, MtProjectUserGroup } from "server/models"
import { StateType } from "client/utils"
import {
    StoreType,
    ProjectGroupUserProps,
    UserFilters,

    SortUsers,
    AddProjectUserGroup,

    closeModal,
    setNotAssignedProjectGroupUserIds,
    setNotAssignedProjectGroupUserSort,
    setNotAssignedProjectGroupUserFilters,
    setNotAssignedProjectGroupUserSelected,
    setProjectGroupUserReloadList,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    PageForm,
    Button,
    TableSearchWrapper,
    Table,
    SortRows,
    SpinnerIcon,
} from "client/components"

import UserSearch from "client/pages/search/userSearch"
import Columns from "./columns"

let isMounted: boolean

const NotAssignedUsers = ({
    group,
}: ProjectGroupUserProps) => {
    const userList = useSelector((state: StoreType) => state.user.userList)

    const projectUserList = useSelector((state: StoreType) => state.projectUser.projectUserList)
    const groupUserList = useSelector((state: StoreType) => state.projectUserGroup.groupUserList)

    const userIds = useSelector((state: StoreType) => state.projectUserGroup.notAssignedUsers.userIds)
    const sortColumn = useSelector((state: StoreType) => state.projectUserGroup.notAssignedUsers.sortColumn)
    const sortOrder = useSelector((state: StoreType) => state.projectUserGroup.notAssignedUsers.sortOrder)
    const filters = useSelector((state: StoreType) => state.projectUserGroup.notAssignedUsers.filters)
    const selected = useSelector((state: StoreType) => state.projectUserGroup.notAssignedUsers.selected)

    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [saveState, setSaveState] = useState<StateType>(IDLE)

    useEffect(() => {
        isMounted = true
        return () => {
            isMounted = false
        }
    }, [])

    useEffect(() => {
        const sortedUserIds = SortUsers(Object.values(userList), sortColumn, sortOrder, filters)
        const groupUserIds = (groupUserList && groupUserList[group.groupId]) || []
        const projectUserIds = (projectUserList && projectUserList[group.projectId]) || []

        const sortedNotAssigned = sortedUserIds.filter((userId) => (
            projectUserIds.includes(userId) && !groupUserIds.includes(userId)
        ))
        dispatch(setNotAssignedProjectGroupUserIds(sortedNotAssigned))
    }, [groupUserList, sortColumn, sortOrder, filters])

    const onSort: SortRows = (column: keyof MtUser, order) => {
        dispatch(setNotAssignedProjectGroupUserSort(column, order))
    }

    const onFilter = (newFilters: UserFilters) => {
        dispatch(setNotAssignedProjectGroupUserFilters(newFilters))
        dispatch(setNotAssignedProjectGroupUserSelected(null))
    }

    const addProjectGroupUsers = () => {
        setSaveState(PENDING)

        const data: MtProjectUserGroup[] = []
        selected.forEach((userId) => {
            data.push({
                userId,
                userProjectId: group.projectId,
                groupId: group.groupId,
                groupAccountId: group.accountId,
                groupProjectId: group.projectId,
            })
        })

        AddProjectUserGroup(data).then(() => {
            if (isMounted) {
                setSaveState(IDLE)
                dispatch(closeModal())
            }
            dispatch(setNotAssignedProjectGroupUserSelected(null))

            dispatch(setProjectGroupUserReloadList(false))
            setTimeout(() => {
                dispatch(setProjectGroupUserReloadList(true))
            }, 0)
        })
    }

    const columns = Columns()

    return (
        <Container>
            <PageHeader>
                <PageTitle>{lang.selectUser_s}</PageTitle>
            </PageHeader>
            <PageContent>
                <TableSearchWrapper>
                    <UserSearch
                        id="notAssignedProjectGroupUsers"
                        filters={filters}
                        onFilter={onFilter}
                    />
                </TableSearchWrapper>
                <Table
                    columns={columns}
                    dataList={userList}
                    dataIds={userIds}
                    selectedIds={selected}
                    sortColumn={sortColumn}
                    sortOrder={sortOrder}
                    rowSize="sm"
                    showPagination
                    onSort={onSort}
                />
                <PageForm>
                    <Button variant="success" onClick={addProjectGroupUsers}>
                        {saveState === PENDING ? <SpinnerIcon /> : lang.select}
                    </Button>
                </PageForm>
            </PageContent>
        </Container>
    )
}
export default NotAssignedUsers
